'use strict';

var Util = require("../layouts/util.js");
var React = require("react");
var ReasonReact = require("reason-react/src/ReasonReact.js");
var SponsorTierModuleScss = require("./sponsorTier.module.scss");

var component = ReasonReact.statelessComponent("SponsorTier");

function make(tier, _) {
  return /* record */[
          /* debugName */component[/* debugName */0],
          /* reactClassInternal */component[/* reactClassInternal */1],
          /* handedOffState */component[/* handedOffState */2],
          /* willReceiveProps */component[/* willReceiveProps */3],
          /* didMount */component[/* didMount */4],
          /* didUpdate */component[/* didUpdate */5],
          /* willUnmount */component[/* willUnmount */6],
          /* willUpdate */component[/* willUpdate */7],
          /* shouldUpdate */component[/* shouldUpdate */8],
          /* render */(function () {
              var match = tier[/* id */0];
              var className;
              switch (match) {
                case "main" : 
                    className = SponsorTierModuleScss.main;
                    break;
                case "regular" : 
                    className = SponsorTierModuleScss.regular;
                    break;
                case "supporter" : 
                    className = SponsorTierModuleScss.supporter;
                    break;
                default:
                  className = SponsorTierModuleScss.root;
              }
              var href = "mailto:hi@reason-conf.com?subject=Sponsoring: " + tier[/* name */1];
              return React.createElement("a", {
                          className: className,
                          href: href
                        }, React.createElement("header", {
                              className: SponsorTierModuleScss.header
                            }, React.createElement("h3", {
                                  className: SponsorTierModuleScss.name
                                }, Util.s(tier[/* name */1])), React.createElement("div", {
                                  className: SponsorTierModuleScss.amount
                                }, React.createElement("h4", {
                                      className: SponsorTierModuleScss.cost
                                    }, Util.s(String(tier[/* cost */2]))), Util.s("€"))), React.createElement("section", {
                              className: SponsorTierModuleScss.description
                            }, Util.md(tier[/* description */4])));
            }),
          /* initialState */component[/* initialState */10],
          /* retainedProps */component[/* retainedProps */11],
          /* reducer */component[/* reducer */12],
          /* subscriptions */component[/* subscriptions */13],
          /* jsElementWrapped */component[/* jsElementWrapped */14]
        ];
}

exports.component = component;
exports.make = make;
/* component Not a pure module */



// WEBPACK FOOTER //
// ./src/components/sponsorTier.js